import { render } from "./UserUpdateProfile.vue?vue&type=template&id=03d3ce5f&scoped=true"
import script from "./UserUpdateProfile.vue?vue&type=script&lang=js"
export * from "./UserUpdateProfile.vue?vue&type=script&lang=js"

import "./UserUpdateProfile.vue?vue&type=style&index=0&id=03d3ce5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d3ce5f"]])

export default __exports__